import { SafeUrl } from "@angular/platform-browser";

export class Branding {
    faviconExtension!: string; 
    faviconUrl!: SafeUrl|null;
    identityLogoExtension!: string;
    identityLogoUrl!: SafeUrl|null;
    platformLogoExtension!: string;
    platformLogoUrl!: SafeUrl|null;
    stampExtension!: string;
    stampUrl!: SafeUrl|null;
    primaryColour!: string|null;
}

export class BrandingPost {
    logo: FormData = new FormData;
    favicon: FormData = new FormData;
    stamp: FormData = new FormData;
    resetPlatformLogo: boolean = false;
    resetIdentityLogo: boolean = false;
    resetFavicon: boolean = false;
    resetStamp: boolean = false;
}

export class BrandingColours {
    //Basic
    fontLightColour: string | undefined; 
    fontDarkColour: string | undefined; 
    headerColour: string | undefined; 
    headerFontColour: string | undefined; 
    headerFontColourType: string | undefined; 
    identityBackgroundColour: string | undefined; 
    identityFontColour: string | undefined; 
    identityFontColourType: string | undefined; 
    primaryColour: string | undefined; 
    primaryHoverColour: string | undefined; 
    primaryDisabledColour: string | undefined; 
    primaryFontColour: string | undefined; 
    primaryFontColourType: string | undefined; 
    secondaryColour: string | undefined; 
    secondaryHoverColour: string | undefined; 
    secondaryDisabledColour: string | undefined; 
    secondaryFontColour: string | undefined; 
    secondaryFontColourType: string | undefined; 
    platformBackgroundColour: string | undefined;
    emailButtonColour: string | undefined;
    emailButtonFontColour: string | undefined;
    emailButtonFontColourType: string | undefined;
    //Advanced
    successColour: string | undefined; 
    successHoverColour: string | undefined; 
    successDisabledColour: string | undefined; 
    successFontColour: string | undefined; 
    successFontColourType: string | undefined; 
    warningColour: string | undefined; 
    warningHoverColour: string | undefined; 
    warningDisabledColour: string | undefined; 
    warningFontColour: string | undefined; 
    warningFontColourType: string | undefined; 
    dangerColour: string | undefined; 
    dangerHoverColour: string | undefined; 
    dangerDisabledColour: string | undefined; 
    dangerFontColour: string | undefined;
    dangerFontColourType: string | undefined;
    infoColour: string | undefined; 
    infoHoverColour: string | undefined; 
    infoDisabledColour: string | undefined; 
    infoFontColour: string | undefined; 
    infoFontColourType: string | undefined; 
}
